<div class="accordion">
  <ng-container>
    <mat-accordion class="accordion__container" multi>
      <mat-expansion-panel
        class="accordion__container__expansion"
        #sectionCollapsed
        ngDefaultControl
        [expanded]="state.isCollapsed"
        (opened)="state.isCollapsed = true"
        (closed)="state.isCollapsed = false"
        [disabled]="!state.accordion"
      >
        <mat-expansion-panel-header (click)="handleHeaderClick($event)"
          class="accordion__container__header"
          [ngStyle]="{ cursor: state.accordion === true ? 'pointer' : 'auto' }"
          tabindex="0"
        >
          <mat-panel-title class="accordion__container__header__title" (click)="handleHeaderClick($event)">
            {{ state.title }}
            <span *ngIf="state.isTooltipPresent">
              <img matTooltipPosition="right" matTooltip={{state.tooltip?.content}} tabindex="0"
                class="info-image--desktop-view " #tooltipdesktop="matTooltip"
                attr.aria-label="{{ state.tooltip?.content }}" alt="info icon" src="assets/info_desktop.svg"
                matTooltipClass="{{state.tooltipClass? state.tooltipClass : 'accordionTooltip'}}"
                matTooltipPositionAtOrigin="true">
              <img id="tooltip-{{state.id}}" matTooltipPosition="below" tabindex="0" (click)="showTooltip()"
                attr.aria-label="{{ state.tooltip?.content }}" class="info-image--mobile-view " alt="info icon" matTooltipClass="accordionTooltip"
                src="assets/info_mobile.svg">
            </span>
          </mat-panel-title>
          <ng-content select="[titleAdditionalInfo]"></ng-content>
          <a
          *ngIf="state.accordion" tabindex="0"
          [attr.aria-expanded]="state.isCollapsed"
          (keypress)="accordionClicked(state.isCollapsed)"
          (click)="accordionClicked(state.isCollapsed)">
            <img *ngIf="state.icon.iconPath" [src]="state.icon.iconPath" [alt]="state.icon.altText" [ngClass]="state.isCollapsed ? 'chevronRotate' : 'chevron'">
          </a> 
          <div class="mydealer__search" *ngIf="state.isSearchFieldPresent">
            <form class="search__wrapper" [formGroup]="searchForm">
              <input
                [placeholder]="state.searchFieldLabels?.search?.placeholder" id="zipCode" formControlName="zipCode" class="search__fields" name="zipCode" type="text"
                maxlength="7" aria-label="search" name="search" autocomplete="off" (keyup)="applysearch($event)" [ngClass]="{'error-input': !isValidZipCode}"
              />
              <button class="clearSearch" [ngClass]="{'clearSearch--input-error': searchForm.get('zipCode')?.hasError('invalidZipCode')}" (click)="clearSearchInput()" (keyup.enter)="clearSearchInput()" aria-label="clear button" tabindex="0" role="button">&times;</button>
              <div class="search-form-error" *ngIf="!isValidZipCode" tabindex="0">
                {{state.searchFieldLabels?.invalidSearchText}}
              </div>
            </form>
           </div>
        </mat-expansion-panel-header>
        <ng-content></ng-content>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
</div>
